class VicienciaDescription extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const full = this.querySelector('.vdesc__full');
    const preview = this.querySelector('.vdesc__preview');
    const button = this.querySelector('.vdesc__toggle');
    if (!full || !preview || !button) return;
    const clone = full.cloneNode(true);
    clone.querySelectorAll('script, style').forEach(node => node.remove());
    clone.querySelectorAll('p, div, br, li, h1, h2, h3, h4, h5, h6, tr').forEach(node => node.after(document.createTextNode(' ')));
    const text = clone.textContent.replace(/\s+/gu, ' ').trim();
    const words = text ? text.split(' ') : [];
    const limit = Math.max(1, Number(this.dataset.words) || 25);
    full.hidden = false;
    preview.hidden = true;
    button.hidden = true;
    if (words.length <= limit) return;
    preview.textContent = words.slice(0, limit).join(' ') + '…';
    const update = expanded => {
      full.hidden = !expanded;
      preview.hidden = expanded;
      button.hidden = false;
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? this.dataset.less : this.dataset.more;
    };
    update(false);
    button.addEventListener('click', () => update(button.getAttribute('aria-expanded') !== 'true'), { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('viciencia-description')) customElements.define('viciencia-description', VicienciaDescription);
